// extracted by mini-css-extract-plugin
module.exports = {"box":"AskAdvisor_box__2eZ-3","link":"AskAdvisor_link__OHJlY"};